export enum WidgetSectionItemSeverity {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  EMPTY = 'empty',
  NONE = 'none',
}
